<template>
  <a-modal
    :visible="open"
    :title="title"
    :confirmLoading="submitLoading"
    @ok="handleSubmit"
    @cancel="handleCancel"
    width="520px"
  >
    <a-form-model ref="form" :model="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
      <a-form-model-item label="分配员工数">
        <span>{{ userIds ? userIds.length : 0 }} 人</span>
      </a-form-model-item>
      <a-form-model-item label="业务积分分类" prop="categoryIds">
        <a-select
          mode="multiple"
          v-model="form.categoryIds"
          :placeholder="$t('请选择业务积分分类（可多选）')"
          allow-clear
          style="width: 100%"
        >
          <a-select-option v-for="item in categoryOptions" :key="item.id" :value="item.id">
            {{ item.categoryName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { listCategory, batchAssignCategory } from '@/api/biz/point'

export default {
  name: 'BatchAssignCategoryModal',
  data() {
    return {
      open: false,
      title: '批量分配业务积分分类',
      submitLoading: false,
      userIds: [],
      categoryOptions: [],
      form: {
        categoryIds: []
      }
    }
  },
  methods: {
    openModal(userIds) {
      this.userIds = userIds || []
      this.open = true
      this.form = { categoryIds: [] }
      this.loadCategories()
    },
    loadCategories() {
      listCategory({}).then(response => {
        this.categoryOptions = response.data || []
      })
    },
    handleSubmit() {
      if (this.userIds.length === 0) {
        this.$message.warning('请先选择员工', 3)
        return
      }
      this.submitLoading = true
      const data = {
        userIds: this.userIds,
        categoryIds: this.form.categoryIds
      }
      batchAssignCategory(data).then(() => {
        this.$message.success('分配成功', 3)
        this.open = false
        this.$emit('ok')
      }).finally(() => {
        this.submitLoading = false
      })
    },
    handleCancel() {
      this.open = false
    }
  }
}
</script>
